import React from "react"
import "./frames.css" // Importando el archivo CSS correcto

const Camilla = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Camilla Stryker Especialmente Adaptada para Cámaras Hiperbáricas de
        Perry Baromedical
      </h1>

      <p className="frames-text">
        Enfocado en ofrecer la mejor experiencia durante los tratamientos de
        terapia hiperbárica, nos enorgullece presentar la camilla Stryker,
        especialmente adaptada para integrarse a la perfección con las cámaras
        hiperbáricas de{" "}
        <a
          href="http://www.perrybaromedical.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>www.perrybaromedical.com</strong>
        </a>
        . Diseñada con características premium que aseguran tanto la comodidad
        como la seguridad del paciente, esta camilla es la opción ideal para
        tratamientos en cámaras hiperbáricas.
      </p>

      <h2 className="frames-subtitle">Características Destacadas</h2>

      <h2 className="frames-subsection">Seguridad y Confort</h2>
      <ul className="frames-text">
        <li>
          Colchoneta Ignífuga: Fabricada con un material resistente al fuego, la
          colchoneta está dividida en dos secciones para ofrecer una mayor
          movilidad del respaldo.
        </li>
        <li>
          Barras Laterales Ajustables: Equipada con barras laterales de
          seguridad que se ajustan al nivel de comodidad y seguridad deseado.
        </li>
        <li>
          Reposabrazos Opcionales: Para mayor comodidad, la camilla ofrece
          reposabrazos opcionales que pueden ser añadidos según la necesidad del
          paciente.
        </li>
      </ul>

      <h2 className="frames-subsection">Versatilidad en Posiciones</h2>
      <ul className="frames-text">
        <li>
          Respaldo Ajustable: El respaldo de la camilla se puede ajustar desde
          una posición vertical hasta completamente tumbado, con ángulos
          disponibles de 15°, 25°, 35°, 45°, 55° y 57 ½°.
        </li>
        <li>
          Elevación Neumática: La camilla se eleva de forma neumática,
          permitiendo un ajuste de altura suave y preciso.
        </li>
      </ul>

      <h2 className="frames-subsection">Facilidad de Movilidad</h2>
      <ul className="frames-text">
        <li>
          Rodamientos de Bronce Anti-Estáticos: Equipada con rollers de bronce
          que disipan la electricidad estática, garantizando un movimiento
          seguro.
        </li>
        <li>
          Movilidad de Ruedas: Dispone de dos posiciones diferentes para la
          movilidad de las ruedas, además de un mecanismo de bloqueo para mayor
          seguridad.
        </li>
      </ul>

      <h2 className="frames-subtitle">Diseño de Alta Calidad</h2>
      <p className="frames-text">
        La camilla ha sido diseñada por Stryker, una marca líder en el ámbito
        médico, y adaptada especialmente para las cámaras hiperbáricas de Perry
        Baromedical. La amplia superficie ajustable en altura facilita el
        acomodo del paciente de manera sencilla y cómoda. Este diseño
        especializado permite el traslado de pacientes por el recinto
        hospitalario hasta la sala de terapia hiperbárica, así como su
        deslizamiento en el interior de la cámara con facilidad y seguridad.
      </p>
    </div>
  )
}

export default Camilla
